export const LMS_INIT_REQUEST = 'LMS_INIT_REQUEST';
export const LMS_INIT_SUCCESS = 'LMS_INIT_SUCCESS';
export const LMS_INIT_FAILURE = 'LMS_INIT_FAILURE';
export const UPDATE_QUERY = 'UPDATE_QUERY';
export const FILTER_REQUEST = 'FILTER_REQUEST';
export const FILTER_REQUEST_SUCCESS = 'FILTER_REQUEST_SUCCESS';
export const FILTER_REQUEST_FAILURE = 'FILTER_REQUEST_FAILURE';

export const LOAD_MORE_REQUEST = 'LOAD_MORE_REQUEST';
export const LOAD_MORE_SUCCESS = 'LOAD_MORE_SUCCESS';
export const LOAD_MORE_FAILURE = 'LOAD_MORE_FAILURE';

export const SORT_REQUEST = 'SORT_REQUEST';
export const SORT_SUCCESS = 'SORT_SUCCESS';
export const SORT_FAILURE = 'SORT_FAILURE';

export const EXPONEA_PUSH = 'EXPONEA_PUSH';
